export const videoKey = 'video' as const;

export const PLAYBACK_MODE = {
  VOD: 0,
  LIVE: 1,
  DVR: 2
};
